/**
 * suspectsCardState — decides when the PROMOTED "might be mislabeled" card
 * shows, and remembers per-swim dismissals. The quiet in-context marker in the
 * set view (SetDetailSheet's `?`) is independent of this and always renders;
 * this module only governs the big Swim-tab card. (Owner walkthrough 2026-07-06:
 * offer, never demand; corrections happen right after a swim, so old swims stay
 * quiet.)
 */

/** Corrections happen right after a swim, occasionally days later, never weeks. */
export const RECENCY_WINDOW_DAYS = 7;

const DISMISS_KEY = "swimset.suspectsDismissed.v1";

/** True when the swim is within the recency window of `nowMs`. Unparseable
 *  dates are treated as NOT recent (fail closed — no billboard). */
export function isRecentSwim(
  swimDateISO: string,
  nowMs: number,
  windowDays: number = RECENCY_WINDOW_DAYS,
): boolean {
  const t = Date.parse(swimDateISO);
  if (Number.isNaN(t)) return false;
  return nowMs - t <= windowDays * 86_400_000;
}

function readDismissed(): Set<string> {
  try {
    if (typeof localStorage === "undefined") return new Set();
    const raw = localStorage.getItem(DISMISS_KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw) as unknown;
    return Array.isArray(arr) ? new Set(arr.filter((x): x is string => typeof x === "string")) : new Set();
  } catch {
    return new Set();
  }
}

export function isDismissed(uuid: string): boolean {
  return readDismissed().has(uuid);
}

export function dismissSwim(uuid: string): void {
  try {
    if (typeof localStorage === "undefined") return;
    const set = readDismissed();
    if (set.has(uuid)) return;
    set.add(uuid);
    localStorage.setItem(DISMISS_KEY, JSON.stringify([...set]));
  } catch {
    /* quota / private mode — degrades to in-session only (known debt) */
  }
}
